export const PIZZERIA_NAME = 'Pizzeria Benvenuti';

export const MANAGING_DIRECTOR = 'Besim Dauti';

const PHONE = '0412 4608 9000';
const PHONE_HREF = 'tel:041246089000';
const WHATSAPP_PHONE = '+49017684215359';
const WHATSAPP_HREF = `https://wa.me/${WHATSAPP_PHONE.replace(/\D/g, '')}`;

export const CONTACT_INFO = {
  phone: PHONE,
  phoneHref: PHONE_HREF,
  whatsapp: WHATSAPP_PHONE,
  whatsappHref: WHATSAPP_HREF,
  email: 'pizzbenvenuti@gmail.com',
  emailHref: 'mailto:pizzbenvenuti@gmail.com',
  addressLines: ['Bahnhofstraße 3-5', '25348 Glückstadt'],
  openingHours: [
    { days: 'Montag', hours: 'Ruhetag' },
    { days: 'Dienstag', hours: '14:00 - 21:00' },
    { days: 'Mittwoch', hours: '14:00 - 21:00' },
    { days: 'Donnerstag', hours: '14:00 - 21:00' },
    { days: 'Freitag', hours: '14:00 - 21:00' },
    { days: 'Samstag', hours: '12:00 - 21:00' },
    { days: 'Sonntag', hours: '12:00 - 21:00' },
  ],
};

const GOOGLE_MAPS_DESTINATION = `${CONTACT_INFO.addressLines[0]}, ${CONTACT_INFO.addressLines[1]}`;

export const GOOGLE_MAPS_DIRECTIONS_URL = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
  GOOGLE_MAPS_DESTINATION
)}`;

export const GOOGLE_MAPS_EMBED_URL = `https://www.google.com/maps?q=${encodeURIComponent(
  GOOGLE_MAPS_DESTINATION
)}&output=embed`;
